import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  AutomotiveAftermarketFiltersDictionaryInitialState,
  AutomotiveAftermarketFiltersDictionaryLoad,
} from './automotive-aftermarket-filters-dictionary.actions';
import { AutomotiveAftermarketFiltersDictionaryState } from './automotive-aftermarket-filters-dictionary.state';
import { MonitoringFilterNameDictionary } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class AutomotiveAftermarketFiltersDictionaryFacade implements LoadDataFacade, SetInitialStateFacade {
  items$: Observable<MonitoringFilterNameDictionary[]> = this.store.select(
    AutomotiveAftermarketFiltersDictionaryState.getItems,
  );
  loaded$: Observable<boolean> = this.store.select(AutomotiveAftermarketFiltersDictionaryState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AutomotiveAftermarketFiltersDictionaryLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new AutomotiveAftermarketFiltersDictionaryInitialState());
  }
}
